import {
  requestSendSMS,
  requestCheckSMS,
} from '@/api/sms';

const state = {
  sendSMS: null,
  checkSMS: null,
};

const getters = {
  sendSMS: (state) => state.sendSMS,
  checkSMS: (state) => state.checkSMS,
};

const actions = {
  async sendSMS({ commit, dispatch, rootGetters }, { postParams }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestSendSMS({ csrfToken, postParams });
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('sendSMS', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async checkSMS({ commit, dispatch, rootGetters }, { postParams }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestCheckSMS({ csrfToken, postParams });
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('checkSMS', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
};

const mutations = {
  sendSMS(state, sendSMS) {
    state.sendSMS = sendSMS;
  },
  checkSMS(state, checkSMS) {
    state.checkSMS = checkSMS;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
